var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"height":"100%","width":"100%"},on:{"load":_vm.renderChildren}})}
var staticRenderFns = []

export { render, staticRenderFns }